/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 752);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(147);

$(function () {
  'use strict';

  window.setTimeout(function () {
    var bubble = new google.bookmarkbubble.Bubble();

    var parameter = 'bmb=1';

    bubble.hasHashParameter = function () {
      return window.location.hash.indexOf(parameter) != -1;
    };

    bubble.setHashParameter = function () {
      if (!this.hasHashParameter()) {
        window.location.hash += parameter;
      }
    };

    bubble.getViewportHeight = function () {
      window.console.log('Example of how to override getViewportHeight.');
      return window.innerHeight;
    };

    bubble.getViewportScrollY = function () {
      window.console.log('Example of how to override getViewportScrollY.');
      return window.pageYOffset;
    };

    bubble.registerScrollHandler = function (handler) {
      window.console.log('Example of how to override registerScrollHandler.');
      window.addEventListener('scroll', handler, false);
    };

    bubble.deregisterScrollHandler = function (handler) {
      window.console.log('Example of how to override deregisterScrollHandler.');
      window.removeEventListener('scroll', handler, false);
    };

    bubble.showIfAllowed();
  }, 1000);
});

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// JavaScript Document

/*
  Copyright 2010 Google Inc.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

/**
 * @fileoverview Bookmark bubble library. This is meant to be included in the
 * main JavaScript binary of a mobile web application.
 *
 * Supported browsers: iPhone / iPod / iPad Safari 3.0+
 */

var google = google || {};
google.bookmarkbubble = google.bookmarkbubble || {};

/**
 * Binds a context object to the function.
 * @param {Function} fn The function to bind to.
 * @param {Object} context The "this" object to use when the function is run.
 * @return {Function} A partially-applied form of fn.
 */
google.bind = function (fn, context) {
  return function () {
    return fn.apply(context, arguments);
  };
};

/**
 * Function used to define an abstract method in a base class. If a subclass
 * fails to override the abstract method, then an error will be thrown whenever
 * that method is invoked.
 */
google.abstractMethod = function () {
  throw Error('Unimplemented abstract method.');
};

/**
 * The bubble constructor. Instantiating an object does not cause anything to
 * be rendered yet, so if necessary you can set instance properties before
 * showing the bubble.
 * @constructor
 */
google.bookmarkbubble.Bubble = function () {
  /**
   * Handler for the scroll event. Keep a reference to it here, so it can be
   * unregistered when the bubble is destroyed.
   * @type {function()}
   * @private
   */
  this.boundScrollHandler_ = google.bind(this.setPosition, this);

  /**
   * The bubble element.
   * @type {Element}
   * @private
   */
  this.element_ = null;

  /**
   * Whether the bubble has been destroyed.
   * @type {boolean}
   * @private
   */
  this.hasBeenDestroyed_ = false;
};

/**
 * Shows the bubble if allowed. It is not allowed if:
 * - The browser is not Mobile Safari, or
 * - The user has dismissed it too often already, or
 * - The hash parameter is present in the location hash, or
 * - The application is in fullscreen mode, which means it was already loaded
 *   from a homescreen bookmark.
 * @return {boolean} True if the bubble is being shown, false if it is not
 *     allowed to show for one of the aforementioned reasons.
 */
google.bookmarkbubble.Bubble.prototype.showIfAllowed = function () {
  if (!this.isAllowedToShow_()) {
    return false;
  }

  this.show_();
  return true;
};

/**
 * Shows the bubble if allowed after loading the icon image. This method creates
 * an image element to load the image into the browser's cache before showing
 * the bubble to ensure that the image isn't blank. Use this instead of
 * showIfAllowed if the image url is http and cacheable.
 * This hack is necessary because Mobile Safari does not properly render
 * image elements with border-radius CSS.
 * @param {function()} opt_callback Closure to be called if and when the bubble
 *        actually shows.
 * @return {boolean} True if the bubble is allowed to show.
 */
google.bookmarkbubble.Bubble.prototype.showIfAllowedWhenLoaded = function (opt_callback) {
  if (!this.isAllowedToShow_()) {
    return false;
  }

  var self = this;
  // Attach to self to avoid garbage collection.
  var img = self.loadImg_ = document.createElement('img');
  img.src = self.getIconUrl_();
  img.onload = function () {
    if (img.complete) {
      delete self.loadImg_;
      img.onload = null; // Break the circular reference.

      self.show_();
      opt_callback && opt_callback();
    }
  };
  img.onload();

  return true;
};

/**
 * Sets the parameter in the location hash. As it is
 * unpredictable what hash scheme is to be used, this method must be
 * implemented by the host application.
 *
 * This gets called automatically when the bubble is shown. The idea is that if
 * the user then creates a bookmark, we can later recognize on application
 * startup whether it was from a bookmark suggested with this bubble.
 *
 * NOTE: Using a hash parameter to track whether the bubble has been shown
 * conflicts with the navigation system in jQuery Mobile. If you are using that
 * library, you should implement this function to track the bubble's status in
 * a different way, e.g. using window.localStorage in HTML5.
 */
google.bookmarkbubble.Bubble.prototype.setHashParameter = google.abstractMethod;

/**
 * Whether the parameter is present in the location hash. As it is
 * unpredictable what hash scheme is to be used, this method must be
 * implemented by the host application.
 *
 * Call this method during application startup if you want to log whether the
 * application was loaded from a bookmark with the bookmark bubble promotion
 * parameter in it.
 *
 * @return {boolean} Whether the bookmark bubble parameter is present in the
 *     location hash.
 */
google.bookmarkbubble.Bubble.prototype.hasHashParameter = google.abstractMethod;

/**
 * The number of times the user must dismiss the bubble before we stop showing
 * it. This is a public property and can be changed by the host application if
 * necessary.
 * @type {number}
 */
google.bookmarkbubble.Bubble.prototype.NUMBER_OF_TIMES_TO_DISMISS = 2;

/**
 * Time in milliseconds. If the user does not dismiss the bubble, it will auto
 * destruct after this amount of time.
 * @type {number}
 */
google.bookmarkbubble.Bubble.prototype.TIME_UNTIL_AUTO_DESTRUCT = 15000;

/**
 * The prefix for keys in local storage. This is a public property and can be
 * changed by the host application if necessary.
 * @type {string}
 */
google.bookmarkbubble.Bubble.prototype.LOCAL_STORAGE_PREFIX = 'BOOKMARK_';

/**
 * The key name for the dismissed state.
 * @type {string}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.DISMISSED_ = 'DISMISSED_COUNT';

/**
 * The arrow image in base64 data url format.
 * @type {string}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.IMAGE_ARROW_DATA_URL_ = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAADTSURBVHjaYjz96mMUAwPDUgbqgTtMQGIZEB+hoqEFTFBGLhD/pYKBW0EYZugFIF5MoYG/QK4EMZiQBGuA+AsFhvaBwhPd0KdA3EqmgSh6mXDZRiJA8SUTrnAhAWDEBxOuGCTBUIyUw4QrrUFdTQhgTeO4DAWF6ywCBoLCsAybBBMeTfVA/A6PfCs01kky9B00VnH5pA+XRiYCXpwFjV10UIkvzAkZ+hcau8gAFDFr8GliIiKGj0BjGZclZBnKAI3l73iCAwWwkJC3QalhLjGKAQIMAK5YMy07l+IQAAAAAElFTkSuQmCC';

/**
 * The close image in base64 data url format.
 * @type {string}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.IMAGE_CLOSE_DATA_URL_ = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAIAAAC0tAIdAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAFESURBVHjaYjrz6uOzrz9+/Pn7HzcAygLVAFWySHKzS3KxM+AF7MxMQDX/GRiYxDjYGIgDIhxsTCxMjHD+zfe//v5HSL/78ffFtz9wLhsTIxOcc/bVD/OVD+J2PYNo+Pjrn9uGx87rHr/+/heuhgXOuvbuJ1DFspufmBkZJ9iJeW58DNTPz8Z0/9NvUU5miBpGoJfhGhZc/5i4+zmQAVQE1Akkt/vLWkpywhUwIfsjQZN/gp04xBnMjAxb/FCUoqsGemvxjY8QNtD1s658QPY0imqgUqC3IG6tNhUGmg3UCXQYsgaE6umXP0CUAt3aYik6x0USomHf469YwqTCRBgYurEa/GbiHBA/gDzw85+rHDdcDePvv/+QIwgP+PPvP9ObH7+IjPk3P36zPP36k5GRUYidlRW3Db///X/38/fTrz8AAgwA0nazwrjpIPYAAAAASUVORK5CYII=';

/**
 * The link used to locate the application's home screen icon to display inside
 * the bubble. The default link used here is for an iPhone home screen icon
 * without gloss. If your application uses a glossy icon, change this to
 * 'apple-touch-icon'.
 * @type {string}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.REL_ICON_ = 'apple-touch-icon-precomposed';

/**
 * Regular expression for detecting an iPhone or iPod or iPad.
 * @type {!RegExp}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.MOBILE_SAFARI_USERAGENT_REGEX_ = /iPhone|iPod|iPad|Android/;

/**
 * Regular expression for detecting an iPad.
 * @type {!RegExp}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.IPAD_USERAGENT_REGEX_ = /iPad/;

google.bookmarkbubble.Bubble.prototype.ANDROID_USERAGENT_REGEX_ = /Android/;

/**
 * Regular expression for extracting the iOS version. Only matches 2.0 and up.
 * @type {!RegExp}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.IOS_VERSION_USERAGENT_REGEX_ = /OS (\d)_(\d)(?:_(\d))?/;

/**
 * Determines whether the bubble should be shown or not.
 * @return {boolean} Whether the bubble should be shown or not.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.isAllowedToShow_ = function () {
  return this.isMobileSafari_() && !this.hasBeenDismissedTooManyTimes_() && !this.isFullscreen_() && !this.hasHashParameter();
};

/**
 * Builds and shows the bubble.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.show_ = function () {
  this.element_ = this.build_();

  document.body.appendChild(this.element_);
  this.element_.style.WebkitTransform = 'translate3d(0,' + this.getHiddenYPosition_() + 'px,0)';

  this.setHashParameter();

  window.setTimeout(this.boundScrollHandler_, 1);
  window.addEventListener('scroll', this.boundScrollHandler_, false);

  // If the user does not dismiss the bubble, slide out and destroy it after
  // some time.
  window.setTimeout(google.bind(this.autoDestruct_, this), this.TIME_UNTIL_AUTO_DESTRUCT);
};

/**
 * Destroys the bubble by removing its DOM nodes from the document.
 */
google.bookmarkbubble.Bubble.prototype.destroy = function () {
  if (this.hasBeenDestroyed_) {
    return;
  }
  window.removeEventListener('scroll', this.boundScrollHandler_, false);
  if (this.element_ && this.element_.parentNode == document.body) {
    document.body.removeChild(this.element_);
    this.element_ = null;
  }
  this.hasBeenDestroyed_ = true;
};

/**
 * Remember that the user has dismissed the bubble once more.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.rememberDismissal_ = function () {
  if (window.localStorage) {
    try {
      var key = this.LOCAL_STORAGE_PREFIX + this.DISMISSED_;
      var value = Number(window.localStorage[key]) || 0;
      window.localStorage[key] = String(value + 1);
    } catch (ex) {
      // Looks like we've hit the storage size limit. Currently we have no
      // fallback for this scenario, but we could use cookie storage instead.
      // This would increase the code bloat though.
    }
  }
};

/**
 * Whether the user has dismissed the bubble often enough that we will not
 * show it again.
 * @return {boolean} Whether the user has dismissed the bubble often enough
 *     that we will not show it again.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.hasBeenDismissedTooManyTimes_ = function () {
  if (!window.localStorage) {
    // If we can not use localStorage to remember how many times the user has
    // dismissed the bubble, assume he has dismissed it. Otherwise we might end
    // up showing it every time the host application loads, into eternity.
    return true;
  }
  try {
    var key = this.LOCAL_STORAGE_PREFIX + this.DISMISSED_;

    // If the key has never been set, localStorage yields undefined, which
    // Number() turns into NaN. In that case we'll fall back to zero for
    // clarity's sake.
    var value = Number(window.localStorage[key]) || 0;

    return value >= this.NUMBER_OF_TIMES_TO_DISMISS;
  } catch (ex) {
    // If we got here, something is wrong with the localStorage. Make the same
    // assumption as when it does not exist at all. Exceptions should only
    // occur when setting a value (due to storage limitations) but let's be
    // extra careful.
    return true;
  }
};

/**
 * Whether the application is running in fullscreen mode.
 * @return {boolean} Whether the application is running in fullscreen mode.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.isFullscreen_ = function () {
  return !!window.navigator.standalone;
};

/**
 * Whether the application is running inside Mobile Safari.
 * @return {boolean} True if the current user agent looks like Mobile Safari.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.isMobileSafari_ = function () {
  return this.MOBILE_SAFARI_USERAGENT_REGEX_.test(window.navigator.userAgent);
};

/**
 * Whether the application is running on an iPad.
 * @return {boolean} True if the current user agent looks like an iPad.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.isIpad_ = function () {
  return this.IPAD_USERAGENT_REGEX_.test(window.navigator.userAgent);
};

google.bookmarkbubble.Bubble.prototype.isAndroid_ = function () {
  return this.ANDROID_USERAGENT_REGEX_.test(window.navigator.userAgent);
};

/**
 * Creates a version number from 4 integer pieces between 0 and 127 (inclusive).
 * @param {*=} opt_a The major version.
 * @param {*=} opt_b The minor version.
 * @param {*=} opt_c The revision number.
 * @param {*=} opt_d The build number.
 * @return {number} A representation of the version.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.getVersion_ = function (opt_a, opt_b, opt_c, opt_d) {
  // We want to allow implicit conversion of any type to number while avoiding
  // compiler warnings about the type.
  return (/** @type {number} */opt_a << 21 |
    /** @type {number} */opt_b << 14 |
    /** @type {number} */opt_c << 7 |
    /** @type {number} */opt_d
  );
};

/**
 * Gets the iOS version of the device. Only works for 2.0+.
 * @return {number} The iOS version.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.getIosVersion_ = function () {
  var groups = this.IOS_VERSION_USERAGENT_REGEX_.exec(window.navigator.userAgent) || [];
  groups.shift();
  return this.getVersion_.apply(this, groups);
};

/**
 * Positions the bubble at the bottom of the viewport using an animated
 * transition.
 */
google.bookmarkbubble.Bubble.prototype.setPosition = function () {
  this.element_.style.WebkitTransition = '-webkit-transform 0.7s ease-out';
  this.element_.style.WebkitTransform = 'translate3d(0,' + this.getVisibleYPosition_() + 'px,0)';
};

/**
 * Destroys the bubble by removing its DOM nodes from the document, and
 * remembers that it was dismissed.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.closeClickHandler_ = function () {
  this.destroy();
  this.rememberDismissal_();
};

/**
 * Gets called after a while if the user ignores the bubble.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.autoDestruct_ = function () {
  if (this.hasBeenDestroyed_) {
    return;
  }
  this.element_.style.WebkitTransition = '-webkit-transform 0.7s ease-in';
  this.element_.style.WebkitTransform = 'translate3d(0,' + this.getHiddenYPosition_() + 'px,0)';
  window.setTimeout(google.bind(this.destroy, this), 700);
};

/**
 * Gets the y offset used to show the bubble (i.e., position it on-screen).
 * @return {number} The y offset.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.getVisibleYPosition_ = function () {
  return this.isIpad_() ? window.pageYOffset + 17 : window.pageYOffset - this.element_.offsetHeight + window.innerHeight - 17;
};

/**
 * Gets the y offset used to hide the bubble (i.e., position it off-screen).
 * @return {number} The y offset.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.getHiddenYPosition_ = function () {
  return this.isIpad_() ? window.pageYOffset - this.element_.offsetHeight : window.pageYOffset + window.innerHeight;
};

/**
 * The url of the app's bookmark icon.
 * @type {string|undefined}
 * @private
 */
google.bookmarkbubble.Bubble.prototype.iconUrl_;

/**
 * Scrapes the document for a link element that specifies an Apple favicon and
 * returns the icon url. Returns an empty data url if nothing can be found.
 * @return {string} A url string.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.getIconUrl_ = function () {
  if (!this.iconUrl_) {
    var link = this.getLink(this.REL_ICON_);
    if (!link || !(this.iconUrl_ = link.href)) {
      this.iconUrl_ = 'data:image/png;base64,';
    }
  }
  return this.iconUrl_;
};

/**
 * Gets the requested link tag if it exists.
 * @param {string} rel The rel attribute of the link tag to get.
 * @return {Element} The requested link tag or null.
 */
google.bookmarkbubble.Bubble.prototype.getLink = function (rel) {
  rel = rel.toLowerCase();
  var links = document.getElementsByTagName('link');
  for (var i = 0; i < links.length; ++i) {
    var currLink = /** @type {Element} */links[i];
    if (currLink.getAttribute('rel').toLowerCase() == rel) {
      return currLink;
    }
  }
  return null;
};

/**
 * Creates the bubble and appends it to the document.
 * @return {Element} The bubble element.
 * @private
 */
google.bookmarkbubble.Bubble.prototype.build_ = function () {
  var bubble = document.createElement('div');
  var isIpad = this.isIpad_();
  var isAndroid = this.isAndroid_();

  bubble.style.position = 'absolute';
  bubble.style.zIndex = 1000;
  bubble.style.width = '100%';
  bubble.style.left = '0';
  bubble.style.top = '0';

  var bubbleInner = document.createElement('div');
  bubbleInner.style.position = 'relative';
  bubbleInner.style.width = '250px';
  bubbleInner.style.height = '65px';
  bubbleInner.style.margin = isIpad ? '0 0 0 82px' : '0 auto';
  bubbleInner.style.padding = '15px 20px 0px 10px';
  bubbleInner.style.WebkitBorderRadius = '8px';
  bubbleInner.style.WebkitBackgroundSize = '100% 8px';
  bubbleInner.style.backgroundColor = '#cbeaf1';
  bubbleInner.style.background =  true ? 'from(#cbeaf1), to(#cbeaf1)) no-repeat top' : 'from(#cbeaf1), to(#cbeaf1)) no-repeat bottom';
  bubbleInner.style.font = '13px/17px sans-serif';
  bubble.appendChild(bubbleInner);

  // The "Add to Home Screen" text is intended to be the exact same text
  // that is displayed in the menu of Android / Mobile Safari.
  if (isAndroid) {
    bubbleInner.innerHTML = '\'ブックマークに追加\'をするとアクセスが簡単です。';
  } else {
    if (this.getIosVersion_() >= this.getVersion_(4, 2)) {
      bubbleInner.innerHTML = '\'ホーム画面に追加\'をするとアクセスが簡単です。';
    } else {
      bubbleInner.innerHTML = '\'ホーム画面に追加\'をするとアクセスが簡単です。';
    }
  }

  var icon = document.createElement('div');
  icon.style['float'] = 'left';
  icon.style.width = '50px';
  icon.style.height = '50px';
  icon.style.margin = '-7px 10px 3px 0px';
  icon.style.background = '#fff url(' + this.getIconUrl_() + ') no-repeat -1px -1px';
  icon.style.WebkitBackgroundSize = '52px';
  icon.style.WebkitBorderRadius = '7px';
  bubbleInner.insertBefore(icon, bubbleInner.firstChild);

  var arrow = document.createElement('div');
  arrow.style.backgroundImage = 'url(' + this.IMAGE_ARROW_DATA_URL_ + ')';
  arrow.style.width = '21px';
  arrow.style.height = '18px';
  arrow.style.position = 'absolute';
  arrow.style.left = '128px';
  if (isIpad) {
    arrow.style.WebkitTransform = 'rotate(180deg)';
    arrow.style.top = '-18px';
  } else {
    arrow.style.bottom = '-18px';
  }
  bubbleInner.appendChild(arrow);

  var close = document.createElement('a');
  close.onclick = google.bind(this.closeClickHandler_, this);
  close.style.position = 'absolute';
  close.style.display = 'block';
  close.style.top = '-3px';
  close.style.right = '8px';
  close.style.width = '16px';
  close.style.height = '16px';
  close.style.border = '10px solid transparent';
  close.style.padding = '2.5px';
  close.style.background = 'url(' + this.IMAGE_CLOSE_DATA_URL_ + ') no-repeat';
  bubbleInner.appendChild(close);

  return bubble;
};

window.google = google;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MORE_UNIT = 3;
var EVENT_TAG = 'dn-sp-more-list';

var SpNews = function () {
  function SpNews() {
    _classCallCheck(this, SpNews);

    this.index = MORE_UNIT;
    this.isDone = false;
    this.$w = $(window);
    this.init();
  }

  _createClass(SpNews, [{
    key: 'init',
    value: function init() {
      var my = this;

      var $container = $('.dn-top-news-sp-container');

      my.$origin = $('.dn-top-news');

      my.$el = my.$origin.clone();
      my.$el.removeClass('dn-top-news--pc').addClass('dn-top-news--sp');
      my.$el.find('.viewPC').remove();
      $container.after(my.$el);
      $container.remove();

      my.$body = my.$el.find('.dn-top-news__body');
      my.$body.after('<dd class="dn-top-news__footer"><a class="dn-top-news__more" href="javascript:void(0);">もっと見る<span class="dn-icon dn-icon-arrow-down"></span></a></dd>');
      my.$trigger = my.$el.find('.dn-top-news__footer a');

      my.$trigger.on('click', function () {
        my.more();
      });
      my.$items = my.$el.find('.dn-top-news__item');
      my.updateHeight(0);

      this.$w.on('resize.' + EVENT_TAG + ' orientationchange.' + EVENT_TAG + ' load.' + EVENT_TAG, function () {
        my.updateHeight(0);
      });
    }
  }, {
    key: 'more',
    value: function more() {
      if (this.isDone) return;
      this.setIndex(this.index + MORE_UNIT);
    }
  }, {
    key: 'setIndex',
    value: function setIndex(index) {
      this.index = Math.min(index, this.$items.length);
      if (this.index === this.$items.length) this.done();
      this.updateHeight();
    }
  }, {
    key: 'updateHeight',
    value: function updateHeight(duration) {
      var my = this;

      duration = typeof duration === 'undefined' ? 500 : duration;

      var height = 0;

      for (var i = 0; i < this.index; i++) {
        var $item = this.$items.eq(i);
        if (!$item.get(0)) break;
        height += $item.outerHeight(true);
      }

      this.$body.stop().animate({ height: height }, duration, 'swing', function () {
        if (my.isDone) my.$body.css({ height: 'auto' });
      });
    }
  }, {
    key: 'done',
    value: function done() {
      this.isDone = true;
      this.$trigger.addClass('dn-top-news__more--done');
      this.$w.off('.' + EVENT_TAG);
    }
  }]);

  return SpNews;
}();

exports.default = SpNews;

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(756),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(753);

__webpack_require__(757);

__webpack_require__(146);

var _spNews = __webpack_require__(148);

var _spNews2 = _interopRequireDefault(_spNews);

__webpack_require__(759);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  new _spNews2.default();
});

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _TopParts = __webpack_require__(754);

var _TopParts2 = _interopRequireDefault(_TopParts);

var _TopPart = __webpack_require__(222);

var _TopPart2 = _interopRequireDefault(_TopPart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component(_TopParts2.default.name, _TopParts2.default);
Vue.component(_TopPart2.default.name, _TopPart2.default);

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopItems = __webpack_require__(755);

var _TopItems2 = _interopRequireDefault(_TopItems);

var _TopPart = __webpack_require__(222);

var _TopPart2 = _interopRequireDefault(_TopPart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-top-parts',

  components: {
    MyItems: _TopItems2.default
  },

  data: function data() {
    var categories = this.getCategories();
    return {
      categories: categories,
      defaultOrders: categories.map(function (c) {
        return c.id;
      })
    };
  },


  computed: {
    orders: function orders() {
      return this.$store.getters['top/parts/orders'] || this.defaultOrders;
    },
    spreadThreshold: function spreadThreshold() {
      return Math.floor(this.categories.length / 2);
    }
  },

  methods: {
    getCategories: function getCategories() {
      var categories = [];
      var $data = $('#data-pg-parts');
      var $categories = $data.children('.category');
      $categories.each(function () {
        var $category = $(this);
        var $label = $category.children('.label');
        var $description = $category.children('.description');
        var $groups = $category.children('.group');
        var $notes = $category.children('.notes');

        var categoryData = $category.data();
        var category = {
          id: categoryData.id,
          status: categoryData.status !== undefined ? String(categoryData.status) : null,
          label: $label.html() || null,
          description: $description.html() || null,
          groups: [],
          notes: $notes.html() || null,
          plainLink: categoryData.plainLink
        };

        $groups.each(function () {
          var $group = $(this);
          var groupData = $group.data();
          var $label = $group.children('.label');
          var $links = $group.children('a');
          var group = {
            id: groupData.id,
            label: $label.html() || null,
            links: []
          };
          category.groups.push(group);

          $links.each(function () {
            var $link = $(this);
            var linkData = $link.data();
            var link = {
              href: $link.prop('href'),
              label: $link.html(),
              auth: !!linkData.auth || linkData.auth === '',
              target: $link.prop('target') || null,
              url_id: linkData.url_id || null
            };
            group.links.push(link);
          });
        });
        categories.push(category);
      });
      return categories;
    }
  },

  created: function created() {
    this.getCategories();
  },
  render: function render(h) {
    var itemsBand = {
      first: [],
      banner: [h('dn-bc-banner', {
        staticClass: 'pg-items__banner',
        props: {
          screen: '102',
          type: '04,05'
        }
      })],
      spBanner: [h('dn-bc-banner', {
        staticClass: 'pg-items__banner',
        props: {
          screen: '102',
          type: '04,05'
        }
      })],
      second: []
    };

    var categories = this.categories,
        orders = this.orders,
        spreadThreshold = this.spreadThreshold;

    orders.forEach(function (id, index) {
      var category = categories.find(function (c) {
        return c.id === id;
      });
      var myTarget = index < spreadThreshold ? 'first' : 'second';
      var part = h(_TopPart2.default, {
        props: {
          index: index,
          id: id,
          label: category.label,
          description: category.description,
          groups: category.groups,
          notes: category.notes,
          status: category.status,
          plain: category.plainLink
        },
        key: id
      });
      itemsBand[myTarget].push(part);
    });

    // const $twitterTimeline = h('div', {
    //   staticClass: 'pg-item-frame pg-item-frame--tw-timeline',
    //   props: {id: 'tw-timeline'},
    //   key: 'tw-timeline',
    // }, [
    //   h('h2', {
    //     staticClass: 'dn-heading-2',
    //   }, 'データネット公式Twitter'),
    //   h('dn-twitter-timeline', {
    //     props: {
    //       href: 'https://twitter.com/kyotsu_DN?ref_src=twsrc%5Etfw',
    //     },
    //   }, 'Tweets by center_DN')
    // ]);

    // itemsBand.second.push($twitterTimeline);

    return h('div', {
      staticClass: 'pg-container'
    }, [h('my-items', { props: { id: 'first' } }, itemsBand.first), h('my-items', { props: { id: 'banner' } }, itemsBand.banner), h('my-items', { props: { id: 'sp-banner' } }, itemsBand.spBanner), h('my-items', { props: { id: 'second' } }, itemsBand.second)]);
  }
};

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'dn-top-items',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'pg-items': true
      }, 'pg-items--' + this.id, true);
    }
  },

  render: function render(h) {
    return h('div', {
      class: this.classes
    }, this.$slots.default);
  }
};

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var TOGGLE_TRANSITION = 350;

exports.default = {
  name: 'dn-top-part',

  props: {
    index: Number,
    id: {
      type: String,
      required: true
    },
    label: String,
    description: String,
    groups: Array,
    notes: String,
    status: String,
    plain: Boolean
  },

  data: function data() {
    return {
      opend: true,
      nowTransition: false
    };
  },


  computed: {
    isOpen: function isOpen() {
      return dn.$store.getters['mq/pc'] || this.opend;
    },
    bodyStyles: function bodyStyles() {
      return this.nowTransition && {
        transition: TOGGLE_TRANSITION + 'ms'
      };
    }
  },

  methods: {
    clearTransitionEndWatcher: function clearTransitionEndWatcher() {
      if (this.transitionEndWatcherId) {
        clearTimeout(this.transitionEndWatcherId);
        delete this.transitionEndWatcherId;
        this.nowTransition = false;
      }
    },
    toggle: function toggle() {
      var _this = this;

      if (!dn.$store.getters['mq/sp']) return;
      this.clearTransitionEndWatcher();
      this.nowTransition = true;
      this.$nextTick(function () {
        _this.opend = !_this.opend;
        _this.transitionEndWatcherId = setTimeout(function () {
          _this.clearTransitionEndWatcher();
        }, TOGGLE_TRANSITION + 100);
      });
    },
    genStatus: function genStatus() {
      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$createElement;

      return h('p', { staticClass: 'pg-item__status' }, this.$status.display(this.status));
    },
    genHeader: function genHeader() {
      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$createElement;

      return h('div', {
        staticClass: 'pg-item__header',
        on: {
          click: this.toggle
        }
      }, [h('h3', {
        staticClass: 'pg-item__name',
        domProps: {
          innerHTML: this.label
        }
      }), this.genStatus(), h('dn-icon', { props: { icon: 'arrow-down' } })]);
    },
    genDescription: function genDescription() {
      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$createElement;

      return h('p', {
        staticClass: 'pg-item__description',
        domProps: {
          innerHTML: this.description
        }
      });
    },
    genLinks: function genLinks() {
      var _this2 = this;

      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$createElement;

      return this.groups.map(function (group) {
        var children = [];
        if (group.label) {
          children.push(h('h4', {
            attrs: {
              'data-label': ''
            },
            domProps: {
              innerHTML: group.label
            }
          }));
        }
        var links = group.links.map(function (link) {
          var attrs = {
            href: link.href
          };
          if (link.target) attrs.target = link.target;

          var directives = link.url_id ? [{ name: 'linkset', value: link.url_id }] : undefined;

          var linkChildren = [h('span', {
            domProps: {
              innerHTML: link.label
            }
          })];

          if (!_this2.plain) {
            linkChildren.push(h('dn-icon', {
              props: {
                icon: 'arrow-right'
              }
            }));
          }

          return h('a', {
            class: {
              'pg-item__link': !_this2.plain,
              'pg-item__link--auth': !_this2.plain && link.auth
            },
            attrs: attrs,
            directives: directives
          }, linkChildren);
        });

        if (_this2.plain) {
          children.push.apply(children, _toConsumableArray(links));
        } else {
          var $linksBody = h('div', {
            staticClass: 'pg-item__links',
            class: {
              'pg-item__links--labeled': !!group.label
            }
          }, links);
          children.push($linksBody);
        }
        return children;
      });
    },
    genBody: function genBody() {
      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$createElement;

      var children = [];
      if (this.description) children.push(this.genDescription());
      children.push(this.genStatus());
      children.push.apply(children, _toConsumableArray(this.genLinks()));
      children.push(this.$slots.default);

      return h('dn-expand-transition', undefined, [h('div', {
        staticClass: 'pg-item__body',
        style: this.bodyStyles,
        directives: [{ name: 'show', value: this.isOpen }]
      }, [h('div', {
        staticClass: 'pg-item__body__inner'
      }, children)])]);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'pg-item-frame',
      attrs: {
        'data-index': this.index
      }
    }, [h('div', {
      staticClass: 'pg-item',
      class: _defineProperty({}, 'pg-item--' + this.id, true)
    }, [this.genHeader(), this.genBody()])]);
  }
};

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _parts = __webpack_require__(758);

var _parts2 = _interopRequireDefault(_parts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

dn.$store.registerModule('top', {
  namespaced: true,

  modules: {
    parts: _parts2.default
  }
});

dn.$store.dispatch('top/parts/load');

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILE_PATH = 'top/conf/parts.json';

exports.default = {
  namespaced: true,

  state: {
    loaded: false,
    data: {
      student: [],
      teacher: []
    }
  },

  getters: {
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('resources', FILE_PATH);
    },
    orders: function orders(state, getters, rootState, rootGetters) {
      var userCategory = rootGetters['segments/user/category'];
      return userCategory && state[userCategory];
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return $http.get(getters['filepath']);

              case 2:
                res = _context.sent;

                commit('setData', res.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mutations: {
    setData: function setData(state, json) {
      Vue.set(state, 'student', json.student);
      Vue.set(state, 'teacher', json.teacher);
      state.loaded = true;
    }
  }
};

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var INTERVAL_CAROUSEL_WAIT = 5000;
var INTERVAL_CAROUSEL_MOVE = 500;
var VECTOR_RIGHT = 'right';
var VECTOR_LEFT = 'left';
var MARGIN_CHILD = parseInt($('.dn-carousel__child').css('margin-right')) * 2;

var DISTANCE_CHILD = {
    get width() {
        this.width_child = $('.dn-carousel__childWrap').width();
        if (this.width_child <= 0) {
            this.width_child = $(window).width();
        }
        return this.width_child;
    }
};
var startCarousel = {
    init: function init() {
        carouselCtrl.init();
        this.setTimer();
    },
    setTimer: function setTimer() {
        this.timer = setTimeout(function () {
            carouselCtrl.checkChildren(VECTOR_LEFT);
        }, INTERVAL_CAROUSEL_WAIT);
        this.isTimer = true;
    },
    clearTimer: function clearTimer() {
        clearTimeout(this.timer);
    }
};

var carouselCtrl = {
    init: function init() {
        this.wrapDOM = $('.dn-carousel__childWrap');
        this.page_max = Math.ceil($('.dn-carousel__child').length / 3);
        console.log(this.page_max);
        this.page_cur = 1;
        this.setArrowAble();
    },
    setArrowAble: function setArrowAble() {
        // 未公開記事もカルーセルに並べるか否か、現状は未公開記事も準備中として並べてる。
        if (this.page_cur == 1) {
            $('#vectorL').addClass('active');
            $('#vectorR').removeClass('active');
        } else if (this.page_cur == this.page_max) {
            $('#vectorL').removeClass('active');
            $('#vectorR').addClass('active');
        } else {
            $('#vectorL').addClass('active');
            $('#vectorR').addClass('active');
        }
    },
    checkChildren: function checkChildren(vector) {
        if (0 <= this.page_cur && this.page_cur <= this.page_max) {
            this.animateChildren(vector);
        }
    },
    animateChildren: function animateChildren(vector) {
        var TARGET_CAROUSEL = $('.dn-carousel__child:first');
        var offsetLeft = parseInt(TARGET_CAROUSEL.css('margin-left'));

        if (this.page_cur == 1) offsetLeft = 4;

        if (startCarousel.isTimer && this.page_cur == this.page_max) {
            offsetLeft = 4;
            this.page_cur = 1;
        } else if (vector == VECTOR_LEFT) {
            offsetLeft -= DISTANCE_CHILD.width;
            if (this.page_cur < this.page_max) this.page_cur++;
        } else {
            offsetLeft += DISTANCE_CHILD.width;
            if (this.page_cur > 0) this.page_cur--;
        }

        TARGET_CAROUSEL.animate({
            marginLeft: offsetLeft
        }, INTERVAL_CAROUSEL_MOVE, function () {
            startCarousel.setTimer();
        });
        // ループ用
        // }, INTERVAL_CAROUSEL_MOVE,function(){carouselCtrl.moveChild(vector)}); 
        startCarousel.clearTimer();
        this.setArrowAble();
    },
    moveChild: function moveChild(vector) {
        if (vector == VECTOR_LEFT) {
            $('.dn-carousel__child:first').appendTo(this.wrapDOM);
        } else {
            $('.dn-carousel__child:last').prependTo(this.wrapDOM);
        }
    }
};

$(function () {
    startCarousel.init();
    $(document).on('click', '#vectorL.active', function () {
        if (!$('.dn-carousel__child:first').is(':animated')) {
            startCarousel.isTimer = false;
            carouselCtrl.checkChildren(VECTOR_LEFT);
        }
    });
    $(document).on('click', '#vectorR.active', function () {
        startCarousel.isTimer = false;
        if (!$('.dn-carousel__child:first').is(':animated')) {
            carouselCtrl.checkChildren(VECTOR_RIGHT);
        }
    });
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// top/js/page.js